import facebookLogo from "../assets/images/logo/socials/facebook.png";
import instagramLogo from "../assets/images/logo/socials/insta-logo.png";
import linkedInLogo from "../assets/images/logo/socials/linkedin.png";
import youTubeLogo from "../assets/images/logo/socials/youtube.png";
import {useTranslation} from "react-i18next";
import {navItems} from "../constants/navDb";
import {Link} from "react-router-dom";

const Footer = () => {
  const {t} = useTranslation();
  return (
    <footer className="grid-pattern bg-white border-t border-theme-color pt-16 pb-5"
            // dir={t?.dir}
    >
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-3 pt-24 upper-footer">
          <div>
            <h4 className="text-theme-color mb-4 text-2xl">{t('common.mission')}</h4>
            {/*<button className="flex items-center gap-2 group w-[150px] 2xl:w-[200px]">*/}
              {/*<img src={majLogo} alt=""/>*/}
              {/*<div className="w-9 h-9 rounded-xl bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center text-white font-black text-lg shadow-lg shadow-cyan-500/30">T</div>*/}
              {/*<span className="text-white font-extrabold text-xl tracking-tight">Tech<span className="text-cyan-400">Pulse</span></span>*/}
            {/*</button>*/}
            <div className="mb-5 text-gray-800 text-sm leading-relaxed">{t('common.ourMission')}</div>
            <ul className="flex gap-5">
              <li>
                <a href="#" rel="noopener noreferrer">
                  <img className="w-10 h-10" src={facebookLogo} alt="Facebook"/>
                </a>
              </li>
              <li>
                <a href="#" rel="noopener noreferrer">
                  <img className="w-10 h-10" src={linkedInLogo} alt="LinkedIn"/>
                </a>
              </li>
              <li>
                <a href="#" rel="noopener noreferrer">
                  <img className="w-10 h-10" src={youTubeLogo} alt="YouTube"/>
                </a>
              </li>
              <li>
                <a href="#" rel="noopener noreferrer">
                  <img className="w-10 h-10" src={instagramLogo} alt="Instagram"/></a>
              </li>
            </ul>
          </div>
          <div className="hidden">
            <h4 className="text-theme-color mb-4 text-2xl">GCC Presence</h4>
            {["UAE", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman"].map(c => (
              <div key={c} className="text-gray-800 text-sm mb-2">{c}</div>
            ))}
          </div>
          <div>
            <h4 className="text-theme-color mb-4 text-2xl">{t('common.services')}</h4>
            {navItems.services.map(nav => (
              <Link to={nav.url} key={nav.url} className="block text-gray-800 hover:text-theme-color text-sm mb-2 transition-colors">
                {t('common.'+nav.translateKey)}
              </Link>
            ))}
          </div>
          <div>
            <h4 className="text-theme-color mb-4 text-2xl">{t('common.contact')}</h4>
            <div className="flex flex-col gap-5 justify-start items-start">
              <div>
                <a href="mailto:info@majtech.ae" className="hover:underline hover:text-theme-color cursor-pointer text-gray-800 text-md mb-2">info@majtech.ae</a>
              </div>
              <div>
                <a href="" target="_blank" rel="noopener noreferrer" href="https://maps.app.goo.gl/dNmHgUHjBnkfdYoj9" className="hover:underline hover:text-theme-color cursor-pointer text-gray-800 text-md">MAJ Technology L.L.C <br/>
                  Al Garhoud Dubai, United Arab Emirates.</a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-theme-color/30 pt-5 text-center text-gray-600 text-sm flex:col md:flex items-center justify-between">
          <div>
            Copyright © {new Date().getFullYear()} MAJ Technology L.L.C. All rights reserved.
          </div>
          <div>
            <Link className="text-theme-color" to={'/privacy-policy'}>{t('homePage.nav.privacy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
